module.exports = __webpack_public_path__ + "static/media/youtube_pos_icon.90c4be6a.svg";